import { useMemo } from "react";

import { useGetSdlJson } from "../../components/hooks";
import { useTableContext } from "../providers";
import { IKeyStringAndValue } from "../types/Types";

//Special cases that uses values from diffrent keys in the same column
const useUpdateRowPumpData = () => {
  const { listView } = useTableContext();
  const rowData = useGetSdlJson(listView).data?.pump;
  return useMemo(() => {
    if (rowData) {
      const updated = rowData.reduce(
        (acc: Array<IKeyStringAndValue>, cur: IKeyStringAndValue) => {
          const curCopy = { ...cur };
          if (curCopy.model_version) {
            curCopy.model_version = curCopy.annual_interval
              ? curCopy.model_version + " " + curCopy.annual_interval
              : curCopy.model_version;
          }
          acc.push(curCopy);
          return acc;
        },
        []
      );

      return updated;
    } else return [];
  }, [rowData]);
};

export default useUpdateRowPumpData;
